<template>
    <div class="card">
        <div class="card-header">
            <h4 class="card-title"><i class="fas fa-comment"></i> Negotiations</h4>
        </div>
        <div class="card-body">
            <div class="chat-box chat-scroll custom-overflow-auto scrollable ps-container ps-theme-default"
                 data-ps-id="a55788c5-c540-351e-4977-542eb3aff414"
                 style="height:calc(100vh - 300px);">
                <ul class="chat-list">
                    <li class="chat-item" v-bind:class="{'odd': currentUser.id === msg.sender_id}" v-bind:key="index"
                        v-for="(msg, index) in conversation">
                        <div class="chat-content">
                            <div class="box bg-light-inverse">{{msg.message}}</div>
                        </div>
                        <div class="chat-time">{{msg.created_at | shorttimestamp}}</div>
                    </li>
                </ul>
                <div class="ps-scrollbar-x-rail" style="left: 0px; bottom: 0px;">
                    <div class="ps-scrollbar-x" style="left: 0px; width: 0px;" tabindex="0"></div>
                </div>
                <div class="ps-scrollbar-y-rail" style="top: 0px; right: 3px;">
                    <div class="ps-scrollbar-y" style="top: 0px; height: 0px;" tabindex="0"></div>
                </div>
            </div>

        </div>
        <div class="card-body border-top">
            <div class="row">
                <div class="col-9">
                    <div class="input-field m-t-0 m-b-0">
                        <textarea class="form-control border-0" placeholder="Type and enter"
                                  v-model="message"></textarea>
                    </div>
                </div>
                <div class="col-3">
                    <button @click="postMessage()" class="btn-circle btn-lg btn-cyan float-right text-white">
                        <i class="fas fa-paper-plane"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "TradeNegotiations",
        props: ['tradeid', 'trade', 'events'],
        computed: {
            ...mapGetters(["currentUser"])
        },
        watch: {
            trade: function (newVal, oldVal) {
                if (this.trade) {
                    this.getMessages();
                }
            }
        },
        data() {
            return {
                message: '',
                conversation: []
            }
        },
        mounted() {
            this.getMessages();
        },
        methods: {
            async postMessage() {
                try {
                    await this.$http.post('/trades/' + this.tradeid + '/chat', {
                        message: this.message,
                        message_props: {}
                    });
                    await this.getMessages();
                    this.message = '';
                } catch (e) {

                }
            },
            async getMessages() {
                if (this.trade) {
                    try {
                        let {data} = await this.$http.get('/trades/' + this.tradeid + '/chat');
                        this.conversation = data;
                    } catch (e) {

                    }
                }
            }
        }
    }
</script>

<style scoped>
    .custom-overflow-auto {
        overflow: auto !important;
    }

    ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px grey;
        border-radius: 10px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: gray;
        border-radius: 10px;
    }
</style>
